import { Setting } from '../utility/Setting';

/**
 * ヘッダー追従制御
 */
export class HeaderFixed {
  /**
   * コンストラクタ
   * @param selector 対象の要素セレクタ
   * @param option 設定オブジェクト
   */
  constructor(selector: string, option: HeaderFixedOption = {
    scrolledClass: 'is-scrolled',
    styleChangePoint: {
      pc: 200,
      sp: 120
    },
    breakPoint: Setting.spWidth
  }) {
    $(selector).each((index: number, element: HTMLElement): void => {
      const $target: JQuery = $(element);
      $target.data('header_fixed', new HeaderFixedObject($target, option));
    });
  }
}

/**
 * オプション
 */
export interface HeaderFixedOption {
  /**
   * スクロールクラス
   */
  scrolledClass: string;

  /**
   * スタイルの変更ポイント
   */
  styleChangePoint: {pc: number, sp: number};

  /**
   * ブレイクポイント
   */
  breakPoint: number
}

/**
 * 実行クラス
 */
class HeaderFixedObject {
  /**
   * 要素オブジェクト
   */
  private readonly el: any;

  /**
   * 状態オブジェクト
   */
  private readonly state: any;

  /**
   * 設定オブジェクト
   */
  private readonly setting: any;

  /**
   * コンストラクタ
   * @param el 対象のJQueryオブジェクト
   * @param option 設定オブジェクト
   */
  constructor(el: JQuery, option: HeaderFixedOption) {
    this.el = {};
    this.state = {};
    this.setting = option;
    this.el.$win = $(window);
    this.el.$root = el;
    this.state.device;
    this.init();
  }

  /**
   * 初期実行メソッド
   */
  private init(): void {
    this.state.device = this.getDevice();
    this.setEvent();
  }

  /**
   * デバイス判定
   * @return 'PC'または'SP'
   */
  private getDevice(): string {
    const winWidth: number = (window.innerWidth) ? window.innerWidth : this.el.$win.width();

    if (winWidth > this.setting.breakPoint) {
      return 'PC';
    } else {
      return 'SP';
    }
  }

  /**
   * ヘッダーのスタイル切り替え
   */
  private switchHeader(): void {
    const scroll: number = this.el.$win.scrollTop();
    const point: number = (this.state.device === 'PC') ? this.setting.styleChangePoint.pc : this.setting.styleChangePoint.sp;

    if (scroll > point) {
      this.el.$root.addClass(this.setting.scrolledClass);
    } else {
      this.el.$root.removeClass(this.setting.scrolledClass);
    }
  }

  /**
   * イベントの設定
   */
  private setEvent(): void {
    let resize: any = 0;

    this.el.$win.on('load scroll', (): void => {
      this.switchHeader();
    });

    this.el.$win.on('resize', (): void => {
      clearTimeout(resize);
      resize = setTimeout((): void => {
        this.state.device = this.getDevice();
        this.switchHeader();
      }, 80);
    });
  }
}
